import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-quarterly-outcome-list',
  templateUrl: './quarterly-outcome-list.component.html',
  styleUrl: './quarterly-outcome-list.component.css',
})
export class QuarterlyOutcomeListComponent {
  @Input() outcomesData: any; // Adjust the type as needed

  // Method to return the label based on status
  getLabel(status: number): string {
    switch (status) {
      case 1:
        return 'Not Started';  // Custom label for status 1
      case 2:
        return 'Ongoing';  // Custom label for status 2
      case 3:
        return 'Completed'; // Custom label for status 3
      case 4:
        return 'Delayed';   // Custom label for status 4
      case 5:
        return 'Terminated';   // Custom label for status 5  
      default:
        return '';  // Default label if status is not 1, 2, or 3
    }
  }
}
